import React from 'react';
import { Users, X, Upload, ArrowBigLeft, User, Phone, CreditCard, Calendar, Shield, Key, FileText } from 'lucide-react';
import '../../../../styles/components/vehicle-register.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import i18n from '../../../../i18n';
import { getLoggedUser } from '../../../../state/user';
import { toast } from 'react-toastify';
import { getVehiclesList } from '../VehicleList/services/VehicleListService';
import { getDriverById } from './services/DriverService';

class DriverRegistration extends React.Component {
    constructor(props) {
        super(props);

        const isEditMode = !!props.match?.params?.id;

        this.state = {
            // Driver Basic Information
            name: '',
            phone: '',
            resident_card_number: '',
            date_of_birth: '',

            // Driver License Information
            license_number: '',
            license_expiry_date: '',

            // Status & Settings
            status: 'P', // P=Pending, A=Active, R=Rejected (default P for new registration)
            opal: true, // true=opal, false=non-opal
            opal_id: '',

            // Driver Qualification
            dd_certificate: '',
            dd_certification_expiry: '',

            // Vehicle Assignment
            vehicle_id: '',
            vehicle_search: '',

            // Files
            photo: null,
            license_copy: null,
            id_copy: null,
            dd_certificate_copy: null,

            // UI States
            showModal: false,
            errors: {},
            isSubmitting: false,
            isEditMode: props.match?.params?.id ? true : false,
            driverId: props.match?.params?.id || null,

            // Vehicle dropdown data (would be fetched from API)
            vehicles: [],
            filteredVehicles: []
        };
    }

    componentDidMount() {
        const pathParts = window.location.pathname.split('/');
        const id = pathParts[pathParts.length - 2];
        console.log("ID from URL:", id);

        if (id && id !== 'edit') {
            this.fetchDriverDetails(id);
        } else {
            console.error('Invalid ID from URL');
            // toast.error('Invalid registration ID');
        }
        this.fetchVehicles();
    }

    // componentDidMount() {
    //     if (this.state.isEditMode) {
    //         this.fetchDriverDetails();
    //     }
    //     this.fetchVehicles();
    // }

    fetchDriverDetails = async (id) => {
        try {
            // TODO: API call to fetch driver details by ID
            const response = await getDriverById(id);
            this.setState(response.data);
        } catch (error) {
            console.error('Error fetching driver details:', error);
            toast.error('Failed to load driver details');
        }
    };

    fetchVehicles = async () => {
        try {
            const response = await getVehiclesList();

            const availableVehicles = response.data.filter(vehicle =>
                !vehicle.driver || vehicle.driver.status !== 'A'
            );

            this.setState({
                vehicles: availableVehicles,
                filteredVehicles: availableVehicles
            });

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            toast.error('Failed to load available vehicles');
        }
    };

    // If you don't have a getVehiclesList function, here's a complete API service example:

    handleInputChange = (field, value) => {
        this.setState({
            [field]: value,
            errors: {
                ...this.state.errors,
                [field]: ''
            }
        });
    };

    handleFileUpload = (field, event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file size (max 6MB)
            if (file.size > 6 * 1024 * 1024) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        [field]: 'File size should be less than 6MB'
                    }
                });
                return;
            }

            // Validate file type
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!validTypes.includes(file.type)) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        [field]: 'Only PDF, JPG, PNG files are allowed'
                    }
                });
                return;
            }

            this.setState({
                [field]: file,
                errors: {
                    ...this.state.errors,
                    [field]: ''
                }
            });
        }
    };

    handleVehicleSearch = (searchTerm) => {
        this.setState({
            vehicle_search: searchTerm,
            filteredVehicles: this.state.vehicles.filter(vehicle =>
                vehicle.vehicle_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
                vehicle.vehicle_model.toLowerCase().includes(searchTerm.toLowerCase())
            )
        });
    };

    validateForm = () => {
        const {
            name,
            phone,
            resident_card_number,
            license_number,
            opal,
            opal_id,
            license_expiry_date,
            dd_certification_expiry,
            photo,
            license_copy,
            id_copy
        } = this.state;

        const errors = {};
        const today = new Date();
        const licenseExpiry = new Date(license_expiry_date);
        const ddExpiry = new Date(dd_certification_expiry);

        // Required fields validation
        if (!name.trim()) {
            errors.name = 'Driver name is required';
        }

        if (!phone.trim()) {
            errors.phone = 'Phone number is required';
        } else if (!/^[\d\s\-\+\(\)]+$/.test(phone)) {
            errors.phone = 'Enter a valid phone number';
        }

        if (!resident_card_number.trim()) {
            errors.resident_card_number = 'Resident card number is required';
        }

        if (!license_number.trim()) {
            errors.license_number = 'License number is required';
        }

        if (!license_expiry_date) {
            errors.license_expiry_date = 'License expiry date is required';
        } else if (licenseExpiry <= today) {
            errors.license_expiry_date = 'License must not be expired';
        }

        // OPAL specific validation
        if (opal) {
            if (!opal_id.trim()) {
                errors.opal_id = 'OPAL ID is required for OPAL drivers';
            }
        }

        if (dd_certification_expiry && ddExpiry <= today) {
            errors.dd_certification_expiry = 'DD certification must not be expired';
        }

        // File validations (required for new registration)
        if (!this.state.isEditMode) {
            if (!photo) {
                errors.photo = 'Driver photo is required';
            }

            if (!license_copy) {
                errors.license_copy = 'License copy is required';
            }

            if (!id_copy) {
                errors.id_copy = 'ID copy is required';
            }
        }

        return errors;
    };

    handleSave = async () => {
        const errors = this.validateForm();

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });

            // Scroll to first error
            const firstErrorField = Object.keys(errors)[0];
            const element = document.querySelector(`[data-field="${firstErrorField}"]`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                element.focus();
            }

            toast.error('Please fix the errors in the form before submitting.');
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            // Prepare form data
            const formData = new FormData();

            // Add all form fields
            const fields = [
                'name', 'phone', 'resident_card_number', 'date_of_birth',
                'license_number', 'license_expiry_date', 'status', 'opal',
                'opal_id', 'dd_certificate', 'dd_certification_expiry', 'vehicle_id'
            ];

            fields.forEach(field => {
                const value = this.state[field];
                if (value !== '' && value !== null && value !== undefined) {
                    // Convert boolean to string for FormData
                    if (typeof value === 'boolean') {
                        formData.append(field, value ? '1' : '0');
                    } else {
                        formData.append(field, value);
                    }
                }
            });

            // Add files
            const fileFields = ['photo', 'license_copy', 'id_copy', 'dd_certificate_copy'];
            fileFields.forEach(field => {
                if (this.state[field]) {
                    formData.append(field, this.state[field]);
                }
            });

            // Log form data (for debugging)
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }

            // TODO: API call
            if (this.state.isEditMode) {
                // await updateDriver(this.state.driverId, formData);
                toast.success('Driver updated successfully!');
            } else {
                // await createDriver(formData);
                toast.success('Driver registered successfully!');
            }

            // Redirect after successful save
            setTimeout(() => {
                this.props.history.push('/drivers');
            }, 1500);

        } catch (error) {
            console.error('Error saving driver:', error);
            const errorMessage = error.response?.data?.message || 'Failed to save driver. Please try again.';
            toast.error(errorMessage);

            // Set validation errors from backend if available
            if (error.response?.data?.errors) {
                this.setState({ errors: error.response.data.errors });
            }
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    handleReset = () => {
        if (window.confirm('Are you sure you want to clear the form?')) {
            this.resetForm();
        }
    };

    resetForm = () => {
        this.setState({
            name: '',
            phone: '',
            resident_card_number: '',
            date_of_birth: '',
            license_number: '',
            license_expiry_date: '',
            status: 'P',
            opal: true,
            opal_id: '',
            dd_certificate: '',
            dd_certification_expiry: '',
            vehicle_id: '',
            vehicle_search: '',
            photo: null,
            license_copy: null,
            id_copy: null,
            dd_certificate_copy: null,
            errors: {}
        });
    };

    handleCancel = () => {
        if (Object.keys(this.state.errors).length > 0 ||
            this.state.name || this.state.license_number) {
            if (!window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
                return;
            }
        }
        this.props.history.push('/drivers');
    };

    handleBackClick = () => {
        this.handleCancel();
    };

    render() {
        const {
            name,
            phone,
            resident_card_number,
            date_of_birth,
            license_number,
            license_expiry_date,
            status,
            opal,
            opal_id,
            dd_certificate,
            dd_certification_expiry,
            vehicle_id,
            vehicle_search,
            errors,
            isSubmitting,
            isEditMode,
            filteredVehicles
        } = this.state;

        const user = getLoggedUser();

        return (
            <React.Fragment>
                <HeaderBanner
                    title={isEditMode ? i18n.t("edit_driver") : i18n.t("driver_registration")}
                    subtitle={isEditMode ? "Edit driver information" : "Register new driver"}
                />
                <section className="mt-5 site-visit-details-page">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div className={this.state.hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'}>
                                <main className="main-content card">
                                    <div className="page-header">
                                        <div>
                                            <button
                                                className="back-button"
                                                onClick={this.handleBackClick}
                                                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                            >
                                                <ArrowBigLeft size={24} />
                                            </button>
                                        </div>
                                        <div className="header-actions">
                                            <button
                                                className="no-data-button me-2"
                                                onClick={this.handleReset}
                                                disabled={isSubmitting}
                                                type="button"
                                            >
                                                {i18n.t('clear_form')}
                                            </button>

                                            <button
                                                className="no-data-button me-2"
                                                onClick={this.handleCancel}
                                                disabled={isSubmitting}
                                                type="button"
                                            >
                                                {i18n.t('cancel')}
                                            </button>

                                            <button
                                                className="btn-new"
                                                onClick={this.handleSave}
                                                disabled={isSubmitting}
                                                type="button"
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                        {isEditMode ? i18n.t('updating') : i18n.t('submitting')}
                                                    </>
                                                ) : (
                                                    isEditMode ? i18n.t('update') : i18n.t('submit')
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="content">
                                        <section className="card-t1 driver-details">
                                            <div className="form-grid">
                                                {/* Section Header */}
                                                <div className="form-group full-width">
                                                    <div className="section-header section-divider">
                                                        <div className="card-t1-header">
                                                            <User size={24} className="header-icon" />
                                                            <h2>{i18n.t('driver_information')}</h2>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Driver Name */}
                                                <div className="form-group" data-field="name">
                                                    <label>Full Name *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter driver's full name"
                                                        value={name}
                                                        onChange={(e) => this.handleInputChange('name', e.target.value)}
                                                        disabled={isSubmitting}
                                                        className={errors.name ? 'error' : ''}
                                                    />
                                                    {errors.name && (
                                                        <span className="error-message">{errors.name}</span>
                                                    )}
                                                </div>

                                                {/* Phone Number */}
                                                <div className="form-group" data-field="phone">
                                                    <label>Contact Number *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="e.g., +971 50 123 4567"
                                                        value={phone}
                                                        onChange={(e) => this.handleInputChange('phone', e.target.value)}
                                                        disabled={isSubmitting}
                                                        className={errors.phone ? 'error' : ''}
                                                    />
                                                    {errors.phone && (
                                                        <span className="error-message">{errors.phone}</span>
                                                    )}
                                                </div>

                                                {/* Resident Card Number */}
                                                <div className="form-group" data-field="resident_card_number">
                                                    <label>Resident Card Number *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter resident card number"
                                                        value={resident_card_number}
                                                        onChange={(e) => this.handleInputChange('resident_card_number', e.target.value)}
                                                        disabled={isSubmitting}
                                                        className={errors.resident_card_number ? 'error' : ''}
                                                    />
                                                    {errors.resident_card_number && (
                                                        <span className="error-message">{errors.resident_card_number}</span>
                                                    )}
                                                </div>

                                                {/* Date of Birth */}
                                                <div className="form-group" data-field="date_of_birth">
                                                    <label>Date of Birth</label>
                                                    <input
                                                        type="date"
                                                        value={date_of_birth}
                                                        onChange={(e) => this.handleInputChange('date_of_birth', e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>

                                                {/* License Number */}
                                                <div className="form-group" data-field="license_number">
                                                    <label>License Number *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter license number"
                                                        value={license_number}
                                                        onChange={(e) => this.handleInputChange('license_number', e.target.value)}
                                                        disabled={isSubmitting}
                                                        className={errors.license_number ? 'error' : ''}
                                                    />
                                                    {errors.license_number && (
                                                        <span className="error-message">{errors.license_number}</span>
                                                    )}
                                                </div>

                                                {/* License Expiry Date */}
                                                <div className="form-group" data-field="license_expiry_date">
                                                    <label>License Expiry Date *</label>
                                                    <input
                                                        type="date"
                                                        value={license_expiry_date}
                                                        onChange={(e) => this.handleInputChange('license_expiry_date', e.target.value)}
                                                        disabled={isSubmitting}
                                                        min={new Date().toISOString().split('T')[0]}
                                                        className={errors.license_expiry_date ? 'error' : ''}
                                                    />
                                                    {errors.license_expiry_date && (
                                                        <span className="error-message">{errors.license_expiry_date}</span>
                                                    )}
                                                </div>

                                                {/* Status (for edit mode only) */}
                                                {isEditMode && (
                                                    <div className="form-group" data-field="status">
                                                        <label>Status</label>
                                                        <select
                                                            value={status}
                                                            onChange={(e) => this.handleInputChange('status', e.target.value)}
                                                            disabled={isSubmitting}
                                                        >
                                                            <option value="P">Pending</option>
                                                            <option value="A">Active</option>
                                                            <option value="R">Rejected</option>
                                                        </select>
                                                    </div>
                                                )}

                                                {/* OPAL Type */}
                                                <div className="form-group full-width">
                                                    <div className="section-header">
                                                        <label>Driver Type</label>
                                                        <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                                                            <button
                                                                type="button"
                                                                className={`no-data-button ${opal ? 'active' : ''}`}
                                                                onClick={() => this.handleInputChange('opal', true)}
                                                                disabled={isSubmitting}
                                                            >
                                                                OPAL Driver
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`no-data-button ${!opal ? 'active' : ''}`}
                                                                onClick={() => this.handleInputChange('opal', false)}
                                                                disabled={isSubmitting}
                                                            >
                                                                Non-OPAL Driver
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* OPAL ID (only for OPAL drivers) */}
                                                {opal && (
                                                    <div className="form-group" data-field="opal_id">
                                                        <label>OPAL ID *</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter OPAL ID"
                                                            value={opal_id}
                                                            onChange={(e) => this.handleInputChange('opal_id', e.target.value)}
                                                            disabled={isSubmitting}
                                                            className={errors.opal_id ? 'error' : ''}
                                                        />
                                                        {errors.opal_id && (
                                                            <span className="error-message">{errors.opal_id}</span>
                                                        )}
                                                    </div>
                                                )}

                                                {/* DD Certificate */}
                                                <div className="form-group" data-field="dd_certificate">
                                                    <label>DD Certificate Date</label>
                                                    <input
                                                        type="date"
                                                        value={dd_certificate}
                                                        onChange={(e) => this.handleInputChange('dd_certificate', e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>

                                                {/* DD Certification Expiry */}
                                                <div className="form-group" data-field="dd_certification_expiry">
                                                    <label>DD Certification Expiry Date</label>
                                                    <input
                                                        type="date"
                                                        value={dd_certification_expiry}
                                                        onChange={(e) => this.handleInputChange('dd_certification_expiry', e.target.value)}
                                                        disabled={isSubmitting}
                                                        min={new Date().toISOString().split('T')[0]}
                                                        className={errors.dd_certification_expiry ? 'error' : ''}
                                                    />
                                                    {errors.dd_certification_expiry && (
                                                        <span className="error-message">{errors.dd_certification_expiry}</span>
                                                    )}
                                                </div>

                                                {/* Vehicle Assignment */}
                                                <div className="form-group full-width">
                                                    <div className="section-header section-divider">
                                                        <div className="card-t1-header">
                                                            <Users size={24} className="header-icon" />
                                                            <h2>{i18n.t('vehicle_assignment')}</h2>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group full-width" data-field="vehicle_id">
                                                    <label>Assign to Vehicle</label>
                                                    <select
                                                        value={vehicle_id}
                                                        onChange={(e) => this.handleInputChange('vehicle_id', e.target.value)}
                                                        disabled={isSubmitting}
                                                    >
                                                        <option value="">Select a vehicle</option>
                                                        {filteredVehicles.map(vehicle => (
                                                            <option key={vehicle.id} value={vehicle.id}>
                                                                {vehicle.vehicle_number} - {vehicle.vehicle_model} ({vehicle.vehicle_type})
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {vehicle_search && (
                                                    <div className="form-group full-width">
                                                        <input
                                                            type="text"
                                                            placeholder="Search vehicles..."
                                                            value={vehicle_search}
                                                            onChange={(e) => this.handleVehicleSearch(e.target.value)}
                                                            disabled={isSubmitting}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* File Upload Section */}
                                            <div className="form-grid">
                                                <div className="form-group full-width">
                                                    <div className="section-header section-divider">
                                                        <div className="card-t1-header">
                                                            <FileText size={24} className="header-icon" />
                                                            <h2>{i18n.t('documents')}</h2>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Driver Photo */}
                                                <div className="form-group" data-field="photo">
                                                    <label>Driver Photo {!isEditMode && '*'}</label>
                                                    <div className="file-upload-wrapper">
                                                        <div className={`file-upload ${errors.photo ? 'error-border' : ''}`}>
                                                            <Upload size={32} />
                                                            <p>
                                                                Drag & drop photo or <span className="browse-link">browse</span>
                                                            </p>
                                                            <small>JPG, PNG Max 6MB</small>
                                                            <input
                                                                type="file"
                                                                accept=".jpg,.jpeg,.png"
                                                                onChange={(e) => this.handleFileUpload('photo', e)}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                        {this.state.photo && (
                                                            <div className="selected-file">
                                                                Selected: {this.state.photo.name}
                                                            </div>
                                                        )}
                                                        {errors.photo && (
                                                            <span className="error-message">{errors.photo}</span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* License Copy */}
                                                <div className="form-group" data-field="license_copy">
                                                    <label>License Copy {!isEditMode && '*'}</label>
                                                    <div className="file-upload-wrapper">
                                                        <div className={`file-upload ${errors.license_copy ? 'error-border' : ''}`}>
                                                            <Upload size={32} />
                                                            <p>
                                                                Drag & drop file or <span className="browse-link">browse</span>
                                                            </p>
                                                            <small>PDF, JPG, PNG Max 6MB</small>
                                                            <input
                                                                type="file"
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                onChange={(e) => this.handleFileUpload('license_copy', e)}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                        {this.state.license_copy && (
                                                            <div className="selected-file">
                                                                Selected: {this.state.license_copy.name}
                                                            </div>
                                                        )}
                                                        {errors.license_copy && (
                                                            <span className="error-message">{errors.license_copy}</span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ID Copy */}
                                                <div className="form-group" data-field="id_copy">
                                                    <label>ID Copy {!isEditMode && '*'}</label>
                                                    <div className="file-upload-wrapper">
                                                        <div className={`file-upload ${errors.id_copy ? 'error-border' : ''}`}>
                                                            <Upload size={32} />
                                                            <p>
                                                                Drag & drop file or <span className="browse-link">browse</span>
                                                            </p>
                                                            <small>PDF, JPG, PNG Max 6MB</small>
                                                            <input
                                                                type="file"
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                onChange={(e) => this.handleFileUpload('id_copy', e)}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                        {this.state.id_copy && (
                                                            <div className="selected-file">
                                                                Selected: {this.state.id_copy.name}
                                                            </div>
                                                        )}
                                                        {errors.id_copy && (
                                                            <span className="error-message">{errors.id_copy}</span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* DD Certificate Copy */}
                                                <div className="form-group" data-field="dd_certificate_copy">
                                                    <label>DD Certificate Copy (Optional)</label>
                                                    <div className="file-upload-wrapper">
                                                        <div className="file-upload">
                                                            <Upload size={32} />
                                                            <p>
                                                                Drag & drop file or <span className="browse-link">browse</span>
                                                            </p>
                                                            <small>PDF, JPG, PNG Max 6MB</small>
                                                            <input
                                                                type="file"
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                onChange={(e) => this.handleFileUpload('dd_certificate_copy', e)}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                        {this.state.dd_certificate_copy && (
                                                            <div className="selected-file">
                                                                Selected: {this.state.dd_certificate_copy.name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </main>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default DriverRegistration;